import type { SagaReturn } from '@types'
import loginSaga from '@views/loginView/state/loginSaga'
import signupSaga from '@views/signupView/state/signupSaga'
import profileSaga from '@views/profile/state/profileSaga'
import { all, fork } from 'redux-saga/effects'
import verifySaga from '@views/home/state/homeSaga'
import trackingSaga from '@views/tracking/state/trackingSaga2'
import referralSaga from '@views/referrals/state/referralSaga'
import resourcesSaga from '@views/resources/state/resourcesSaga'
import configurationsSaga from '@views/configurations/state/configurationsSaga'
import manageSaga from '@views/manage/state/manageSaga'
import commissionsSaga from '@views/commissionsReferrals/state/commissionsSaga'
import prepaymentsSaga from '@views/prepayments/state/prepaymentsSaga'
import analystTrackSaga from '@views/analystTrack/state/analystTrackSaga'
import analystCasesSaga from '@views/analystCases/state/analystCasesSaga'
import analystRejectedSaga from '@views/analystRejected/state/analystRejectedSaga'
import clubSaga from '@views/club/state/clubSaga'
import executiveCommissionsSaga from '@views/executiveCommissions/state/executiveCommissionsSaga'
import agentCommissionsSaga from '@views/agentCommissions/state/agentCommissionsSaga'
import executiveMetricsSaga from '@views/executiveMetrics/state/executiveMetricsSaga'
import agentMetricsSaga from '@views/agentMetrics/state/agentMetricsSaga'

function* rootSaga(): SagaReturn {
  try {
    yield all([
      fork(loginSaga),
      fork(signupSaga),
      fork(clubSaga),
      fork(trackingSaga),
      fork(referralSaga),
      fork(resourcesSaga),
      fork(configurationsSaga),
      fork(profileSaga),
      fork(verifySaga),
      fork(manageSaga),
      fork(commissionsSaga),
      fork(prepaymentsSaga),
      fork(analystTrackSaga),
      fork(analystCasesSaga),
      fork(analystRejectedSaga),
      fork(executiveCommissionsSaga),
      fork(agentCommissionsSaga),
      fork(agentMetricsSaga),
      fork(executiveMetricsSaga)
      // Add your sagas here
    ])
  } catch (error) {
    // Add your error handler here
  }
}

export default rootSaga
